module.exports = __webpack_public_path__ + "img/foto-conhecimento.aa63a953.png";